import { render, staticRenderFns } from "./ReleaseProfile.vue?vue&type=template&id=21ad9c72&scoped=true"
import script from "./ReleaseProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReleaseProfile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ReleaseProfile.vue?vue&type=style&index=0&id=21ad9c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad9c72",
  null
  
)

export default component.exports